import { File, FileAudio, FileCsv, FileDoc, FileImage, FileJpg, FilePdf, FilePng, FileText, FileTxt, FileVideo, FileXls, FileZip, Icon } from "@phosphor-icons/react";
import { Message } from "../../../models/Message";
import { DocumentView } from "./styles";
import { ReactNode, useState } from "react";
import { FileMetadata } from "../../../models/FileMetadata";
import { formatBytes } from "../../../utils/formatBytes";
import { formatDuration } from "../../../utils/time";
import { User } from "../../../models/User";
import { Contact } from "../../../models/Contact";
import { FileShowModal } from "../../Modals/FileShowModal";
import { MessageTextContent } from "../TextContent";

export interface DocumentProps {
  message: Message;
  user: User;
  contact: Contact;
};

export const Document = ({
  message,
  contact,
  user,
}: DocumentProps ) => {
  const [ open, setOpen ] = useState<boolean>( false );

  const getIconFile = ( extension: FileMetadata["extension"], mimetype: FileMetadata["mimeType"]): ReactNode => {
    mimetype = mimetype.split("/").shift() ?? "";

    const iconExtensionFileMapper: {
      [ key: string ]: Icon;
    } = {
      pdf: FilePdf,
      txt: FileTxt,
      csv: FileCsv,
      doc: FileDoc,
      jpg: FileJpg,
      jpeg: FileJpg,
      png: FilePng,
      zip: FileZip,
      xls: FileXls,
    };

    const iconMimetypeFileMapper: {
      [ key: string ]: Icon;
    } = {
      image: FileImage,
      audio: FileAudio,
      video: FileVideo,
      text: FileText,
    };

    const Icon = iconExtensionFileMapper[ extension ] ?? iconMimetypeFileMapper[ mimetype ] ?? File

    return (
      <Icon
        size={ 40 }
        weight="light"
      />
    );
  };

  return (
    <DocumentView>
      <button
        type="button"
        className="file-info-view"
        aria-label={ `Abrir arquivo ${ message.fileMetadata?.fileName ?? "anexado" }` }
        onClick={() => setOpen( true )}
      >
        { getIconFile( message.fileMetadata?.extension as string, message.fileMetadata?.mimeType as string )}

        <div className="file-info">
          <span>{ message.fileMetadata?.fileName }</span>

          <span>
            { message.fileMetadata?.extension.toUpperCase()} • { formatBytes( message.fileMetadata?.size ?? 0, 0 )}
            { message.fileMetadata?.pages ? ` • ${ message.fileMetadata.pages } página${ message.fileMetadata.pages > 1 ? "s" : ""}` : ""}
            { message.fileMetadata?.duration ? ` • ${ formatDuration(( message.fileMetadata.duration ) * 1000 )}` : ""}
          </span>
        </div>
      </button>

      {
        message.content !== "" && (
          <MessageTextContent content={ message.content } />
        )
      }

      {
        open && (
          <FileShowModal
            message={ message }
            open={ open }
            onClose={() => setOpen( false )}
            user={ user }
            contact={ contact }
          />
        )
      }
    </DocumentView>
  );
};
